import api from '@/api.js'

const state = {
    templates: [],
    lists: []
}

const getters = {
    templates: state => {
        return state.templates;
    },
    lists: state => {
        return state.lists;
    },
    isTemplates: state => {
        return state.templates.length;
    },
    isLists: state => {
        return state.lists.length;
    },
    list: state => {
        return (id) => {
            const o = state.lists.find(e => { return e.idx == id });
            return o ? o : {};
        }
    },

}
const actions = {
    LOAD_LISTS: function (context) {
        api.getLists().then(response => {
            context.commit("setLists", response);
        });
    },
    INSERT_LIST: function (context, payload) {
        api.insertList(payload).then(response => {
            if (response) context.commit("insertList", { ...payload, idx: response })
        })
    },
    UPDATE_LIST: function (context, payload) {
        api.updateList(payload).then(response => {
            if (response) context.commit("updateList", payload)
        })
    },
    COPY_LIST: function (context, payload) {
        api.copyList(payload).then(response => {
            if (response) context.commit("copyList",  { ...payload, idx: response })
        })
    },
    DELETE_LIST: function (context, payload) {
        api.deleteList(payload.idx).then(response => {
            if (response) context.commit("deleteList", payload)
        })
    },
    LOAD_TEMPLATES: function (context) {
        api.getTemplates().then(response => {
            context.commit("setTemplates", response);
        });
    },
    UPDATE_TEMPLATE: function (context, payload) {
        api.updateTemplate(payload.item).then(response => {
            if (response) context.commit("updateTemplate", payload);
        });
    },
    INSERT_TEMPLATE: function (context, payload) {
        api.insertTemplate(payload).then(response => {
            if (response) context.commit("insertTemplate", { ...payload, idx: response });
        });
    },
    DELETE_TEMPLATE: function (context, payload) {
        api.deleteTemplate(payload.idx).then(response => {
            if (response) context.commit("deleteTemplate", payload);
        });
    },
}
const mutations = {
    setLists: (state, payload) => {
        state.lists = payload;
    },
    setTemplates: (state, payload) => {
        state.templates = payload;
    },
    updateTemplate: (state, payload) => {
        Object.assign(state.templates[payload.index], payload.item);
    },
    insertTemplate: (state, payload) => {
        state.templates.push({ ...payload });
    },
    insertList: (state, payload) => {
        state.lists.push({ ...payload });
    },
    copyList: (state, payload) => {
        state.lists.push({ ...payload });
    },
    updateList: (state, payload) => {
        let l = state.lists.find(e => { return e.idx == payload.idx });
        if(l) Object.assign(l, payload);
    },
    deleteList: (state, payload) => {
        const index = state.lists.indexOf(payload);
        state.lists.splice(index, 1)
    },
    deleteTemplate: (state, payload) => {
        const index = state.templates.indexOf(payload);
        state.templates.splice(index, 1)
    },
}

const Data = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Data;